import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { loadCldr } from '@syncfusion/ej2-base';

import * as gregorian from '@syncfusion/ej2-cldr-data/main/nl/ca-gregorian.json';
import * as numbers from '@syncfusion/ej2-cldr-data/main/nl/numbers.json';
import * as timeZoneNames from '@syncfusion/ej2-cldr-data/main/nl/timeZoneNames.json';
import * as numberingSystems from '@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json';

loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);

@Component({
  selector: 'cp-root',
  templateUrl: './customer-portal.component.html',
})
export class CustomerPortalComponent {
  constructor(translate: TranslateService) {
    translate.setDefaultLang('en');
  }
}
